<template>
    <Doughnut
        id="my-chart-id"
        :options="chartOptions"
        :chart-data="chartData"
    />
</template>

<script>
import {Doughnut} from 'vue-chartjs/legacy';
import {Chart as ChartJS, Title, Tooltip, Legend, CategoryScale, LinearScale, ArcElement} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale)

export default {
    name: 'DoughnutChart',
    props: ['chartData', 'chartOptions',],
    components: {Doughnut},
    data() {
        return {
        }
    }
}
</script>
